<div>
  <div class="manage-connections-headers">
    <div class="page-title">Manage Connections</div>
    @if (!loading && connections.length > 0) {
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'manage-connection'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    }
  </div>

  <div class="table-actions-bar">
    <div class="action-buttons">
      <button
        type="button"
        class="action-btn links-btn"
        (click)="viewConnectionLinks()"
      >
        <span>View Links</span>
      </button>
      <button
        type="button"
        class="action-btn create-btn"
        (click)="showConnectionTypePopup = true"
      >
        <span>Create Connection</span>
      </button>
    </div>
  </div>

  <app-table
    [columns]="tableColumns"
    [data]="connections"
    [loading]="loading"
    [noResultsMessage]="'No connections found.'"
    [skeletonRows]="5"
  >
    <ng-template let-connection>
      <tr>
        <td>
          <div class="connection-info">
            <div
              class="name"
              [title]="connection.display_name || connection.name"
            >
              {{ connection.display_name || connection.name }}
            </div>
            <div class="system-name" [title]="connection.name">
              {{ connection.name }}
            </div>
          </div>
        </td>
        <td>
          <span
            class="strategy-pill"
            [class.type-enterprise]="connection.connection_type !== 2"
            [class.type-data-hub]="connection.connection_type === 2"
            [title]="getStrategyLabel(connection)"
          >
            {{ getStrategyLabel(connection) }}
          </span>
        </td>
        <td>
          @if (connection.domain) {
            <span class="domain-pill" [title]="connection.domain">
              {{ connection.domain }}
            </span>
          } @else {
            <span class="empty-cell">-</span>
          }
        </td>
        <td>
          <span
            class="status-badge"
            [class.visibility-hidden]="connection.hide"
            [class.visibility-public]="!connection.hide"
          >
            <span class="status-dot"></span>
            {{ getVisibilityLabel(connection) }}
          </span>
        </td>
        <td>
          <div class="action-icons">
            <a
              href="javascript:void(0)"
              (click)="viewConnectionDetails(connection)"
            >
              View
            </a>
          </div>
        </td>
      </tr>
    </ng-template>
  </app-table>
</div>

@if (!loading && totalConnections > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalConnections"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (showConnectionDetailsPopup) {
  <app-secondary-popup
    [title]="
      selectedConnection.display_name
        ? selectedConnection.display_name
        : selectedConnection.name
    "
    [isActionButtonsAvailable]="false"
    (popupClosed)="onDetailsPopupClose($event)"
  >
    <app-connection-details
      [connection]="selectedConnection"
      (connectionDeletedEventEmitter)="onConnectionDelete($event)"
    ></app-connection-details>
  </app-secondary-popup>
}

@if (showCreateConnectionPopup) {
  <app-popup
    [heading]="'Create Connection'"
    [confirmText]="'Create'"
    [cancelText]="'Cancel'"
    (confirmClicked)="createConnection()"
    (cancelClicked)="cancelCreateConnection()"
  >
    <div class="connection-popup">
      @if (errorMessage !== "") {
        <div class="error">
          <span>{{ errorMessage }}</span>
        </div>
      }
      <div class="connection-popup-item">
        <span>Connection Name:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="creatingConnection.name"
          name="connectionName"
          (input)="validateConnection()"
          #id="ngModel"
        />
        @if (validationErrors.name) {
          <div class="error-msg">{{ validationErrors.name }}</div>
        }
      </div>
      <div class="connection-popup-item">
        <span>Display Name:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="creatingConnection.display_name"
          name="displayName"
          (input)="validateConnection()"
          #id="ngModel"
        />
        @if (validationErrors.display_name) {
          <div class="error-msg">{{ validationErrors.display_name }}</div>
        }
      </div>
      <div class="connection-popup-item">
        <span>Strategy:</span>
        <select
          class="connection-name-input"
          [(ngModel)]="creatingConnection.strategy"
          name="connectionStrategy"
          (change)="validateConnection()"
          required
        >
          <option value="" disabled selected>Select a strategy</option>
          @for (strategy of strategyKeys; track strategy) {
            <option [value]="strategy">
              {{ strategies[strategy] }}
            </option>
          }
        </select>
        @if (validationErrors.strategy) {
          <div class="error-msg">{{ validationErrors.strategy }}</div>
        }
      </div>

      <div class="connection-popup-item">
        <span>Domain:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="creatingConnection.domain"
          name="connectionDomain"
          (input)="validateConnection()"
          #id="ngModel"
        />
        @if (validationErrors.domain) {
          <div class="error-msg">{{ validationErrors.domain }}</div>
        }
      </div>

      <div class="connection-popup-item">
        <span>Client ID:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="creatingConnection.client_id"
          name="connectionClientID"
          (input)="validateConnection()"
          #id="ngModel"
        />
        @if (validationErrors.client_id) {
          <div class="error-msg">{{ validationErrors.client_id }}</div>
        }
      </div>

      <div class="connection-popup-item">
        <span>Client Secret:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="creatingConnection.client_secret"
          name="connectionClientSecret"
          (input)="validateConnection()"
          #id="ngModel"
        />
        @if (validationErrors.client_secret) {
          <div class="error-msg">{{ validationErrors.client_secret }}</div>
        }
      </div>
    </div>
  </app-popup>
}

@if (showConnectionTypePopup) {
  <app-popup
    [showFooterButtons]="false"
    [heading]="'Select Connection Type'"
    [showCloseIcon]="true"
    (cancelClicked)="showConnectionTypePopup = false"
  >
    <div class="connection-user-type-container">
      <div class="connection-user-type-selection">
        <a
          href="javascript:void(0);"
          class="connection-user-type"
          (click)="selectUserType('DH')"
        >
          <h3>Data Hub Connection</h3>
          <p>
            Create a connection to add a user to the Data Hub with a simplified
            setup.
          </p>
        </a>
        <a
          href="javascript:void(0);"
          class="connection-user-type"
          (click)="selectUserType('Enterprise')"
        >
          <h3>Enterprise Connection</h3>
          <p>
            Create a connection in auth0 to add an enterprise user with advanced
            configuration.
          </p>
        </a>
      </div>
    </div>
  </app-popup>
}

@if (showDHUserConnectionPopup) {
  <app-popup
    [heading]="'Create DH User Connection'"
    [confirmText]="'Create'"
    [cancelText]="'Cancel'"
    (confirmClicked)="createDHUserConnection()"
    (cancelClicked)="cancelDHUserConnection()"
  >
    <div class="connection-popup">
      @if (errorMessage !== "") {
        <div class="error">
          <span>{{ errorMessage }}</span>
        </div>
      }
      <div class="connection-popup-item">
        <span>Connection Name:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="dhUserConnection.name"
          name="dhConnectionName"
          (input)="validateDHUserConnection()"
          placeholder="Enter connection name"
        />
        @if (dhUserValidationErrors.name) {
          <div class="error-msg">{{ dhUserValidationErrors.name }}</div>
        }
      </div>
      <div class="connection-popup-item">
        <span>Display Name:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="dhUserConnection.display_name"
          name="dhDisplayName"
          (input)="validateDHUserConnection()"
          placeholder="Enter display name"
        />
        @if (dhUserValidationErrors.display_name) {
          <div class="error-msg">{{ dhUserValidationErrors.display_name }}</div>
        }
      </div>
    </div>
  </app-popup>
}

@if (showConnectionModePopup) {
  <app-popup
    [showFooterButtons]="false"
    [heading]="'Select Connection Creation Mode'"
    [showCloseIcon]="true"
    (cancelClicked)="showConnectionModePopup = false"
  >
    <div class="connection-type-container">
      <div class="connection-type-back-button">
        <a
          href="javascript:void(0);"
          class="back-link"
          (click)="goBackToUserTypeSelection()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 512 512"
            fill="none"
            stroke="currentColor"
            stroke-width="32"
          >
            <path d="M244 400L100 256l144-144M120 256h292" />
          </svg>
          Back
        </a>
      </div>
      <div class="connection-type-selection">
        <a
          href="javascript:void(0);"
          class="connection-type"
          (click)="selectConnectionType('manual')"
        >
          <h3>Manual Setup</h3>
          <p>
            Configure your connection manually by providing connection details
          </p>
        </a>
        <a
          href="javascript:void(0);"
          class="connection-type"
          (click)="selectConnectionType('link')"
        >
          <h3>Quick Connect</h3>
          <p>Use Auth0's quick connect feature to set up your connection</p>
        </a>
      </div>
    </div>
  </app-popup>
}

@if (showConnectionLinkCreationPopup) {
  <app-popup
    [heading]="'Create Connection Link'"
    [confirmText]="'Create'"
    [cancelText]="'Cancel'"
    (confirmClicked)="createConnectionLink()"
    (cancelClicked)="cancelConnectionLinkCreation()"
  >
    <div class="connection-popup">
      @if (errorMessage !== "") {
        <div class="error">
          <span>{{ errorMessage }}</span>
        </div>
      }
      <div class="connection-popup-item">
        <span>Connection Name:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="creatingConnectionLink.connection_name"
          name="connectionLinkName"
          (input)="validateConnectionLink()"
        />
        @if (connectionLinkValidationErrors.connection_name) {
          <div class="error-msg">
            {{ connectionLinkValidationErrors.connection_name }}
          </div>
        }
      </div>
      <div class="connection-popup-item">
        <span>Display Name:</span>
        <input
          class="connection-name-input"
          type="text"
          [(ngModel)]="creatingConnectionLink.display_name"
          name="connectionLinkDisplayName"
          (input)="validateConnectionLink()"
        />
        @if (connectionLinkValidationErrors.display_name) {
          <div class="error-msg">
            {{ connectionLinkValidationErrors.display_name }}
          </div>
        }
      </div>
      <div class="connection-popup-item">
        <span>Validity (days):</span>
        <input
          class="connection-name-input"
          type="number"
          min="1"
          [(ngModel)]="creatingConnectionLink.validity"
          name="connectionLinkValidity"
          (input)="validateConnectionLink()"
        />
        @if (connectionLinkValidationErrors.validity) {
          <div class="error-msg">
            {{ connectionLinkValidationErrors.validity }}
          </div>
        }
      </div>
      <div class="connection-popup-item">
        <span>Allowed Visits:</span>
        <input
          class="connection-name-input"
          type="number"
          min="1"
          [(ngModel)]="creatingConnectionLink.allowed_visits"
          name="connectionLinkAllowedVisits"
          (input)="validateConnectionLink()"
        />
        @if (connectionLinkValidationErrors.allowed_visits) {
          <div class="error-msg">
            {{ connectionLinkValidationErrors.allowed_visits }}
          </div>
        }
      </div>
    </div>
  </app-popup>
}

@if (showGeneratedLinkPopup) {
  <app-popup
    [heading]="'Connection Link Generated'"
    [confirmText]="CopyConfirmText"
    [cancelText]="'Close'"
    (confirmClicked)="copyGeneratedLink(generatedLink)"
    (cancelClicked)="closeGeneratedLinkPopup()"
  >
    <div class="generated-link-popup">
      <p>Your connection link has been generated:</p>
      <div class="link-container">
        <code>{{ generatedLink }}</code>
      </div>
      <p class="hint">Click 'Copy' to copy the link to your clipboard.</p>
    </div>
  </app-popup>
}

@if (showConnectionLinksPopup) {
  <app-secondary-popup
    [title]="'View Connection Links'"
    [isActionButtonsAvailable]="false"
    (popupClosed)="onConnectionLinksPopupClose()"
  >
    @if (showDeleteLinkPopup) {
      <app-popup
        [heading]="'Delete Connection Link'"
        [confirmText]="'Delete'"
        [cancelText]="'Cancel'"
        [popupPosition]="'absolute'"
        (confirmClicked)="deleteLink()"
        (cancelClicked)="showDeleteLinkPopup = false"
      >
        <div class="delete-link-confirmation">
          <div class="link-details">
            <div class="detail-row">
              <span class="label">Connection:</span>
              <span class="value">{{
                selectedConnectionLink.connection_name
              }}</span>
            </div>
            <div class="detail-row">
              <span class="label">Display Name:</span>
              <span class="value">{{
                selectedConnectionLink.display_name
              }}</span>
            </div>
            <div class="detail-row">
              <span class="label">Usage:</span>
              <span class="value"
                >{{ selectedConnectionLink.visits }}/{{
                  selectedConnectionLink.allowed_visits
                }}
                visits</span
              >
            </div>
            <div class="detail-row">
              <span class="label">Expiry:</span>
              <span class="value">{{
                selectedConnectionLink.expiry | date
              }}</span>
            </div>
          </div>
          <div class="warning-text">
            This action cannot be undone. The link will become invalid and
            anyone with this link will no longer be able to access the
            connection setup.
          </div>
        </div>
      </app-popup>
    }
    <div class="connection-links-container">
      <div class="connection-links-header">
        <h3>Connection Links</h3>
        <a
          href="javascript:void(0)"
          (click)="openConnectionLinkCreationPopup()"
        >
          <span>Create</span>
        </a>
      </div>
      @if (!loadingLinks) {
        @if (connectionLinks.length > 0) {
          <!-- Admin Generated Links Section -->
          @if (adminLinks.length > 0) {
            <div class="links-section">
              <div
                class="section-header-clickable"
                (click)="toggleAdminLinks()"
                (keydown.enter)="toggleAdminLinks()"
                (keydown.space)="toggleAdminLinks()"
                tabindex="0"
                role="button"
                [attr.aria-expanded]="isAdminLinksExpanded"
                aria-label="Toggle admin generated links section"
              >
                <div class="section-title">
                  <div class="title-wrapper">
                    <span class="title-text">Admin Generated Links</span>
                    <span class="section-badge admin-badge">
                      {{ adminLinks.length }}
                    </span>
                  </div>
                  <svg
                    class="expand-icon"
                    [class.collapsed]="!isAdminLinksExpanded"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
                <div class="section-description">
                  Links created by administrators and shared with organization
                </div>
              </div>
              @if (isAdminLinksExpanded) {
                @for (link of adminLinks; track $index) {
                  <div
                    class="connection-link-item admin-link"
                    [class.expired]="!isLinkValid(link)"
                  >
                    <div class="status-icon">
                      @if (!isLinkValid(link)) {
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 640 512"
                          width="15px"
                          height="15px"
                          fill="#ef4444"
                        >
                          <path
                            d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
                          />
                        </svg>
                      } @else {
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 640 512"
                          width="15px"
                          height="15px"
                          fill="#334ea5"
                        >
                          <path
                            d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                          />
                        </svg>
                      }
                    </div>
                    <div class="link-details">
                      <div class="link-name">{{ link.display_name }}</div>
                      <div class="link-info">
                        <div class="connection-line">
                          <span>Connection: {{ link.connection_name }}</span>
                        </div>
                        <div class="status-line">
                          <span [class.exceeded]="isVisitsExceeded(link)"
                            >Visits: {{ link.visits }}/{{
                              link.allowed_visits
                            }}</span
                          >
                          <span [class.exceeded]="isLinkExpired(link)"
                            >{{ isLinkExpired(link) ? "Expired" : "Expires" }}:
                            {{ link.expiry | date }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="action-buttons">
                      @if (isLinkValid(link)) {
                        <button
                          class="copy-button"
                          [class.copied]="copiedLinkId === link.generated_link"
                          (click)="
                            copyGeneratedLink(
                              link.generated_link,
                              link.generated_link
                            )
                          "
                          title="Copy link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="15px"
                            width="15px"
                            viewBox="0 0 448 512"
                            fill="#fff"
                          >
                            <path
                              d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"
                            />
                          </svg>
                        </button>
                      } @else {
                        <button
                          class="recreate-button"
                          (click)="recreateLink(link)"
                          title="Recreate link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            width="15px"
                            height="15px"
                            fill="#fff"
                          >
                            <path
                              d="M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
                            />
                          </svg>
                        </button>
                      }
                      <button
                        class="delete-button"
                        (click)="onDeleteConnectionLink(link)"
                        title="Delete link"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="15px"
                          width="15px"
                          viewBox="0 0 448 512"
                          fill="#fff"
                        >
                          <path
                            d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                }
              }
            </div>
          }

          <!-- Self-Signup Links Section -->
          @if (selfSignupLinks.length > 0) {
            <div class="links-section">
              <div
                class="section-header-clickable"
                (click)="toggleSelfSignupLinks()"
                (keydown.enter)="toggleSelfSignupLinks()"
                (keydown.space)="toggleSelfSignupLinks()"
                tabindex="0"
                role="button"
                [attr.aria-expanded]="isSelfSignupLinksExpanded"
                aria-label="Toggle self-signup links section"
              >
                <div class="section-title">
                  <div class="title-wrapper">
                    <span class="title-text">Self-Signup Links</span>
                    <span class="section-badge signup-badge">
                      {{ selfSignupLinks.length }}
                    </span>
                  </div>
                  <svg
                    class="expand-icon"
                    [class.collapsed]="!isSelfSignupLinksExpanded"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
                <div class="section-description">
                  Links generated from the self-signup public form
                </div>
              </div>
              @if (isSelfSignupLinksExpanded) {
                @for (link of selfSignupLinks; track $index) {
                  <div
                    class="connection-link-item signup-link"
                    [class.expired]="!isLinkValid(link)"
                  >
                    <div class="status-icon">
                      @if (!isLinkValid(link)) {
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 640 512"
                          width="15px"
                          height="15px"
                          fill="#ef4444"
                        >
                          <path
                            d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
                          />
                        </svg>
                      } @else {
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 640 512"
                          width="15px"
                          height="15px"
                          fill="#10b981"
                        >
                          <path
                            d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                          />
                        </svg>
                      }
                    </div>
                    <div class="link-details">
                      <div class="link-name">{{ link.display_name }}</div>
                      <div class="link-info">
                        <div class="connection-line">
                          <span>Connection: {{ link.connection_name }}</span>
                        </div>
                        <div class="status-line">
                          <span [class.exceeded]="isVisitsExceeded(link)"
                            >Visits: {{ link.visits }}/{{
                              link.allowed_visits
                            }}</span
                          >
                          <span [class.exceeded]="isLinkExpired(link)"
                            >{{ isLinkExpired(link) ? "Expired" : "Expires" }}:
                            {{ link.expiry | date }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="action-buttons">
                      @if (isLinkValid(link)) {
                        <button
                          class="copy-button"
                          [class.copied]="copiedLinkId === link.generated_link"
                          (click)="
                            copyGeneratedLink(
                              link.generated_link,
                              link.generated_link
                            )
                          "
                          title="Copy link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="15px"
                            width="15px"
                            viewBox="0 0 448 512"
                            fill="#fff"
                          >
                            <path
                              d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"
                            />
                          </svg>
                        </button>
                      } @else {
                        <button
                          class="recreate-button"
                          (click)="recreateLink(link)"
                          title="Recreate link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            width="15px"
                            height="15px"
                            fill="#fff"
                          >
                            <path
                              d="M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
                            />
                          </svg>
                        </button>
                      }
                      @if (!link.org_self_signup) {
                        <button
                          class="delete-button"
                          (click)="onDeleteConnectionLink(link)"
                          title="Delete link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="15px"
                            width="15px"
                            viewBox="0 0 448 512"
                            fill="#fff"
                          >
                            <path
                              d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
                            />
                          </svg>
                        </button>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          }
        } @else {
          <div class="no-connections">No connection links found.</div>
        }
      } @else {
        <div class="skeleton-box"></div>
        <div class="skeleton-box"></div>
      }
    </div>
  </app-secondary-popup>
}
